import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import BackSection from '../Services/BackSection';
import css from '../Assignments/style.module.css';

export default function LoadingAssignment() {
    return (
        <section>
            <div className='d-flex justify-content-between align-items-center mt-3'>
                <div style={{ margin: '5px 0 7px' }}>
                    <Skeleton baseColor="var(--surface-sunken)" highlightColor="var(--canvas)" width={450} height={30} />
                </div>
                <div className="text-muted">
                    Total Assignments: <strong><Skeleton baseColor="var(--surface-sunken)" highlightColor="var(--canvas)" width={50} /></strong>
                </div>
            </div>

            <table className="table-bordered documents rounded-table ms-1 p-0" style={{ marginTop: "10px" }}>
                <thead>
                    <tr>
                        <th scope="col" className="py-1 px-2">#</th>
                        <th scope="col" className="py-1 px-2">Subject</th>
                        <th scope="col" className="py-1 px-2">Priority</th>
                        <th scope="col" className="py-1 px-2">Status</th>
                        <th scope="col" className="py-1 px-2">Due Date</th>

                    </tr>
                </thead>
                <tbody>
                    {Array.from({ length: 5 }).map((_, index) => (
                        <tr key={index} >
                            {Array.from({ length: 5 }).map((_, index) => (
                                <th key={index} scope="row" className="py-1 px-2 border">
                                    <Skeleton baseColor="var(--surface-sunken)" highlightColor="var(--canvas)" width={150} />
                                </th>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </section>
    )
}
export function AssignmentDetailsLoading() {
    return (
        <div>
            <div>
                <div className='d-flex align-items-center justify-content-between'>
                    <h1 className='mt-3 ps-0 h2 fw-bold ms-1'><Skeleton baseColor="var(--surface-sunken)" highlightColor="var(--canvas)" width={300} /></h1>
                    <button className={`${css.addButton} rounded-5`}>
                        <Skeleton baseColor="var(--surface-sunken)" width={100} />
                    </button>
                </div>
                <div className="container">
                    <div className={`row ${css.infoCard} overflow-hidden`}>
                        {Array.from({ length: 4 }).map((_, index) => (
                            <div key={index} className="col-md-3 py-2">
                                <p className={`m-0 p-0 ${css.infoLabel}`}><Skeleton baseColor="var(--surface-sunken)" highlightColor="var(--canvas)" width={150} /></p>
                                <p className='m-0 p-0 fw-bold'><Skeleton baseColor="var(--surface-sunken)" highlightColor="var(--canvas)" width={200} /></p>
                            </div>
                        ))}
                    </div>
                    <div className="mt-3">
                        <div className={`row ${css.infoCard} overflow-hidden px-3 py-2`}>
                            <p className={`m-0 p-0 ${css.infoLabel}`}><Skeleton baseColor="var(--surface-sunken)" highlightColor="var(--canvas)" width={350} /></p>
                            {Array.from({ length: 4 }).map((_, index) => (
                                <p key={index} className='m-0 p-0 fw-bold w-100'><Skeleton baseColor="var(--surface-sunken)" highlightColor="var(--canvas)" /></p>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
